import { render, staticRenderFns } from "./touxi.vue?vue&type=template&id=a291a46e&scoped=true&"
import script from "./touxi.vue?vue&type=script&lang=js&"
export * from "./touxi.vue?vue&type=script&lang=js&"
import style0 from "./touxi.vue?vue&type=style&index=0&id=a291a46e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a291a46e",
  null
  
)

export default component.exports